import { observable } from "mobx";
import RejectedCustomerRefundCandidateStatus from "./rejectedCustomerRefundCandidateStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RejectedCustomerRefundCandidateSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  status?: RejectedCustomerRefundCandidateStatus;

  @observable
  officialRecordId?: string;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  variableSymbol?: number;
}
